export const userTabs = {
    Algemeen: "algemeen",
    Scholen: "scholen",
    VrijeVelden: "vrijeVelden",
    AfasKoppeling: "afasKoppeling",
}